import AgentRead from 'models/agent_read';
import createConverter from './lib/create_converter';

export default createConverter(AgentRead);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/agent_read_converter.js